import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

export const authCodeFlowConfig: AuthConfig = {
	issuer: environment.oAuth.issuer,

	// URL of the SPA to redirect the user to after login
	redirectUri: environment.oAuth.redirectUri,
	postLogoutRedirectUri: environment.oAuth.postLogoutRedirectUri,

	// The SPA's id. The SPA is registerd with this id at the auth-server
	clientId: environment.oAuth.clientId,
	tokenEndpoint: environment.oAuth.tokenEndpoint,
	silentRefreshRedirectUri: environment.oAuth.silentRefreshRedirectUri,
	responseType: "code",
	oidc: true,
	sessionChecksEnabled: false,

	// set the scope for the permissions the client should request
	scope: environment.oAuth.scope,
	showDebugInformation: false,
};
